export default class Scadenzario{
    CodiceAttivita;
    DescrAttivita;
    CodiceEntita;
    DescrEntita;
    CodiceSito;
    DescrSito;
    GlbUnita;
    DescrUnita;
    TokReparto;
    DescrReparto;
    TokComparto;
    DescrComparto;
    Responsabile;
    DataProssima;
    SysChiaveglobale;
    Responsabile;

    constructor(){}

}